export default class PlayerBase {
  constructor(parent) {
    this.parent = parent;
  }

  get model() {
    return this.parent.model;
  }

  set model(model) {
    this.parent.model = model;
  }

  unload() {
    throw Error('No unload() has been setup');
  }

  destroy() {
    throw Error('No destroy() has been setup');
  }

  load() {
    throw Error('No load() has been setup');
  }

  fastForward() {
    throw Error('No fastForward() has been setup');
  }

  rewind() {
    throw Error('No rewind() has been setup');
  }

  seek() {
    throw Error('No seek() has been setup');
  }

  play() {
    throw Error('No play() has been setup');
  }

  pause() {
    throw Error('No pause() has been setup');
  }

  togglePlay() {
    throw Error('No togglePlay() has been setup');
  }

  toggleMute() {
    throw Error('No toggleMute() has been setup');
  }

  changeVolume(volume) {
    throw Error('No changeVolume() has been setup. Trying to adjust volume to:', volume);
  }

  changeAudioPreference(audioPreference) {
    throw Error('No changeAudioPreference() has been setup. Trying to adjust preference to:',
      audioPreference);
  }

  changeTextTrackPreference(textTrackPreference) {
    throw Error('No changeTextTrackPreference() has been setup. Trying to adjust preference to:',
      textTrackPreference);
  }

  changeBitratePreference(qualityPreference) {
    throw Error('No changeBitratePreference() has been setup. Trying to adjust preference to:',
      qualityPreference);
  }

  skip() {
    throw Error('No skip() has been setup');
  }

  openAdWebsite() {
    throw Error('No openAdWebsite() has been setup');
  }
}
